module.exports = __webpack_public_path__ + "img/group-icon.84be3559.svg";